module.exports = __webpack_public_path__ + "img/staygoldbaby_hair.f3936f86.jpg";